import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../../stores';
import * as Constants from "../../../Constants";
import { Property } from 'csstype';
import * as styles from "../DesignSettingsPanel.css";
import * as adminStyles from '../../AdminStyles.css';
import { IADropDown } from '../../../../dropDown/DropDown';
import { IAColorPicker } from '../../../../colorPicker/ColorPicker';
import { LocalizationService } from '../../../../../services/LocalizationService';

export interface IElementsSettingsProps {
  navigatorStore?: NavigatorStore;
}

@inject('navigatorStore')
@observer
export default class ElementsSettings extends React.Component<IElementsSettingsProps, {}> {

  private readonly localizationService = new LocalizationService();

  public componentDidMount(): void {
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    return (
      <div className={styles.pivotContentItem}>
        <IAColorPicker
          label={this.localizationService.strings.Navigator_Design_TextColor}
          color={this.props.navigatorStore.navigator.design.elements.textColor}
          onChange={(color: string) => this.props.navigatorStore.setElementTextColor(color)}
          showClearButton={false}
        />
        <div className={adminStyles.panelDivider} />
        <IADropDown
          label={this.localizationService.strings.Navigator_Design_FontSize}
          selectedOption={this.props.navigatorStore.navigator.design.elements.fontSize as string}
          options={Constants.FONT_SIZES}
          onChange={(fontSize: Property.FontSize<number>) => this.props.navigatorStore.setElementFontSize(fontSize)}
          style={{ width: 155, float: "left" }}
          borderRadius={5}
        />
        <IADropDown
          label={this.localizationService.strings.Navigator_Design_FontWeight}
          selectedOption={this.props.navigatorStore.navigator.design.elements.fontWeight as string}
          options={Constants.FONT_WEIGHTS}
          onChange={(fontWeight: string) => this.props.navigatorStore.setElementFontWeight(fontWeight)}
          style={{ width: 155, clear: "none", marginLeft: 20, float: "left" }}
          borderRadius={5}
        />
        <IADropDown
          label={this.localizationService.strings.Navigator_Design_TextTransform}
          selectedOption={this.props.navigatorStore.navigator.design.elements.textTransform}
          options={Constants.TEXT_TRANSFORMS}
          onChange={(textTransform: Property.TextTransform) => this.props.navigatorStore.setElementTextTransform(textTransform)}
          style={{ width: 155, float: "left" }}
          borderRadius={5}
        />
        <IADropDown
          label={this.localizationService.strings.Navigator_Design_LetterSpacing}
          selectedOption={this.props.navigatorStore.navigator.design.elements.letterSpacing}
          options={Constants.LETTER_SPACING}
          onChange={(letterSpacing: string) => this.props.navigatorStore.setElementLetterSpacing(letterSpacing)}
          style={{ width: 155, float: "left", clear: "none", marginLeft: 20 }}
          borderRadius={5}
        />
        <IADropDown
          label={this.localizationService.strings.Navigator_Design_TextIndentation}
          selectedOption={this.props.navigatorStore.navigator.design.elements.indentation != undefined ? this.props.navigatorStore.navigator.design.elements.indentation.toString() : "0"}
          options={Constants.INDENT}
          onChange={(indentation: string) => this.props.navigatorStore.setElementIndentation(indentation)}
          style={{ width: 155, float: "left" }}
          borderRadius={5}
        />
        <IADropDown
          label={"Padding"}
          selectedOption={this.props.navigatorStore.navigator.design.elements.padding ?? "25px"}
          options={Constants.NAVIGATOR_PADDING}
          onChange={(padding: string) => this.props.navigatorStore.setElementPadding(padding)}
          style={{ width: 155, float: "left", clear: "none", marginLeft: 20 }}
          borderRadius={5}
        />
        <div className={adminStyles.panelDivider} />
        <IAColorPicker
          label={this.localizationService.strings.Navigator_Design_IconColor}
          color={this.props.navigatorStore.navigator.design.elements.iconColor}
          onChange={(color: string) => this.props.navigatorStore.setElementIconColor(color)}
          showClearButton={false}
        />
        <div className={adminStyles.panelDivider} />
      </div>
    );
  }
}